import { render, staticRenderFns } from "./Swapp.vue?vue&type=template&id=64bc6524&scoped=true"
import script from "./Swapp.vue?vue&type=script&lang=js"
export * from "./Swapp.vue?vue&type=script&lang=js"
import style0 from "./Swapp.vue?vue&type=style&index=0&id=64bc6524&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bc6524",
  null
  
)

export default component.exports